import { influencersParceiros } from '../../../mocks/influencers-parceiros';

export default function DepoimentosInfluencers() {
  return (
    <section className="py-24 bg-gradient-to-br from-amber-50 via-white to-rose-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-white rounded-full mb-6 border border-amber-200">
            <i className="ri-chat-quote-line text-amber-600"></i>
            <span className="text-sm font-semibold text-amber-800 tracking-wide">PARCEIRAS OFICIAIS</span>
          </div>
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Quem Já Está
            <span className="block text-amber-600 mt-2">Transformando Vidas</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conheça algumas das influencers que já fazem parte do programa e estão gerando impacto real
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {influencersParceiros.map((influencer) => (
            <div 
              key={influencer.id}
              className="bg-white p-8 rounded-3xl border-2 border-amber-100 hover:shadow-2xl hover:scale-105 transition-all duration-300"
            >
              {/* Photo */}
              <div className="relative mb-6">
                <div className="w-24 h-24 mx-auto rounded-full overflow-hidden border-4 border-amber-200">
                  <img 
                    src={influencer.foto} 
                    alt={influencer.nome}
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Verified Badge */}
                <div className="absolute bottom-0 right-1/2 translate-x-12 w-8 h-8 bg-amber-600 rounded-full flex items-center justify-center border-2 border-white">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
              </div>

              {/* Info */}
              <div className="text-center mb-6">
                <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-1">
                  {influencer.nome}
                </h3>
                <a 
                  href={`https://instagram.com/${influencer.instagram.replace('@', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-amber-600 hover:text-amber-700 font-semibold flex items-center justify-center gap-1"
                >
                  <i className="ri-instagram-line"></i>
                  <span>{influencer.instagram}</span>
                </a>
                <div className="text-sm text-gray-500 mt-1">
                  {influencer.seguidores} seguidores
                </div>
              </div>

              {/* Testimonial */}
              <div className="relative">
                <i className="ri-double-quotes-l text-4xl text-amber-200 absolute -top-2 -left-2"></i>
                <p className="text-gray-600 leading-relaxed italic pl-6">
                  {influencer.depoimento}
                </p>
              </div>

              {/* Stats */}
              <div className="mt-6 pt-6 border-t border-amber-100">
                <div className="flex items-center justify-center gap-2 text-amber-600">
                  <i className="ri-user-add-line text-xl"></i>
                  <span className="font-semibold">{influencer.conversoes} pessoas impactadas</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-xl text-gray-700 mb-6">
            Faça parte deste time de transformação
          </p>
          <a 
            href="#formulario"
            className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-amber-600 to-amber-500 text-white rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span>Quero Ser Parceira</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}